"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var TopGamesListCtl = /** @class */ (function (_super) {
    __extends(TopGamesListCtl, _super);
    function TopGamesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_top_game_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.top_game_type_code; });
        _this.dk_top_game_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.top_game_type_title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_gws_gameprovider_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_id; });
        _this.dk_gws_gameprovider_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_title; });
        _this.dk_gws_gameprovider_game_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_id; });
        _this.dk_gws_gameprovider_game_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_title; });
        _this.dk_is_auto_select_game = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_auto_select_game; });
        _this.dk_cms_gameprovider_gameset_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameprovider_gameset_id; });
        _this.dk_cms_gameprovider_gameset_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameprovider_gameset_title; });
        _this.dk_date_selected2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_selected2; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        //public readonly dk_is_custom_interval = UIUtils.IProp2Str((o: ITopGameItem) => { o.is_custom_interval });
        _this.dk_change_game_interval_min = UIUtils_1.UIUtils.IProp2Str(function (o) { o.change_game_interval_min; });
        _this._errDialog = errDialog;
        return _this;
    }
    TopGamesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    TopGamesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "top game with id [" + id + "] not found !";
    };
    TopGamesListCtl.prototype.LoadData = function (allBrands, brandsIdList, onDone) {
        var _this = this;
        webAApi_1.ListCmsTopGamesByBrandIdGet.exec({ all_brands: allBrands, brand_id_list: brandsIdList }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    top_game_type_code: resp.list[i].top_game_type_code,
                    top_game_type_title: resp.list[i].top_game_type_title,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    cms_gameprovider_gameset_id: resp.list[i].cms_gameprovider_gameset_id,
                    cms_gameprovider_gameset_title: resp.list[i].cms_gameprovider_gameset_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    date_selected2: moment(resp.list[i].date_selected_uts_ms).utc(false),
                    gws_gameprovider_game_id: resp.list[i].gws_gameprovider_game_id,
                    gws_gameprovider_game_title: resp.list[i].gws_gameprovider_game_title,
                    gws_gameprovider_id: resp.list[i].gws_gameprovider_id,
                    gws_gameprovider_title: resp.list[i].gws_gameprovider_title,
                    is_auto_select_game: resp.list[i].is_auto_select_game,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    //is_custom_interval: resp.list[i].is_custom_interval,
                    change_game_interval_min: resp.list[i].change_game_interval_min,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    TopGamesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddCmsTopGame.exec({
            data: {
                brand_id: data.brand_id,
                top_game_type_code: data.top_game_type_code,
                cms_gameprovider_gameset_id: data.cms_gameprovider_gameset_id,
                gws_gameprovider_id: data.gws_gameprovider_id,
                gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                is_auto_select_game: data.is_auto_select_game,
                app_currency_id: data.app_currency_id,
                //is_custom_interval: data.is_custom_interval,
                change_game_interval_min: data.change_game_interval_min,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_selected2: moment(resp.date_selected_uts_ms).utc(false),
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                cms_gameprovider_gameset_id: data.cms_gameprovider_gameset_id,
                cms_gameprovider_gameset_title: resp.cms_gameprovider_gameset_title,
                gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                gws_gameprovider_game_title: resp.gws_gameprovider_game_title,
                gws_gameprovider_id: data.gws_gameprovider_id,
                gws_gameprovider_title: resp.gws_gameprovider_title,
                is_auto_select_game: data.is_auto_select_game,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                top_game_type_code: data.top_game_type_code,
                top_game_type_title: resp.top_game_type_title,
                //is_custom_interval: data.is_custom_interval,
                change_game_interval_min: data.change_game_interval_min,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    TopGamesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditCmsTopGame.exec({
                data: {
                    cms_top_game_id: data.key,
                    cms_gameprovider_gameset_id: data.cms_gameprovider_gameset_id,
                    gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                    gws_gameprovider_id: data.gws_gameprovider_id,
                    is_auto_select_game: data.is_auto_select_game,
                    app_currency_id: data.app_currency_id,
                    top_game_type_code: data.top_game_type_code,
                    //is_custom_interval: data.is_custom_interval,
                    change_game_interval_min: data.change_game_interval_min,
                }
            }, function (resp) {
                _tmp.cms_gameprovider_gameset_id = data.cms_gameprovider_gameset_id;
                _tmp.cms_gameprovider_gameset_title = resp.cms_gameprovider_gameset_title;
                _tmp.app_currency_id = data.app_currency_id;
                _tmp.app_currency_title = resp.app_currency_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.date_selected2 = moment(resp.date_selected_uts_ms).utc(false);
                _tmp.gws_gameprovider_game_id = data.gws_gameprovider_game_id;
                _tmp.gws_gameprovider_game_title = resp.gws_gameprovider_game_title;
                _tmp.gws_gameprovider_id = data.gws_gameprovider_id;
                _tmp.gws_gameprovider_title = resp.gws_gameprovider_title;
                _tmp.is_auto_select_game = data.is_auto_select_game;
                _tmp.top_game_type_code = data.top_game_type_code;
                _tmp.top_game_type_title = resp.top_game_type_title;
                //_tmp.is_custom_interval = data.is_custom_interval;
                _tmp.change_game_interval_min = data.change_game_interval_min;
                //_tmp.selected_year = data.selected_year;
                //_tmp.selected_month = data.selected_month;
                //_tmp.selected_day = data.selected_day;
                //_tmp.selected_hour = data.selected_hour;
                //_tmp.selected_minute = data.selected_minute;
                //_tmp.selected_second = data.selected_second;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    TopGamesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    TopGamesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteCmsTopGame.exec({ data: { cms_top_game_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return TopGamesListCtl;
}(BaseController_1.BaseController));
exports.TopGamesListCtl = TopGamesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_top_games/ctl/TopGamesListCtl.ts
// module id = 929
// module chunks = 0